export default "__VITE_ASSET__7f667dbe__"